<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import * as store from "../stores/store";

    export let params;

    let bcnc_CODE = params.bcnc_CODE;
    let page = params.page;

    let pageSize = 20; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    onMount(() => {
        getData();
    });

    async function getData() {
        const response = await api.get(`/as/history/${bcnc_CODE}`);

        if (response.data.length == 0) {
            alert("검색 결과가 없습니다.");
            window.history.back();
        }

        if (response != null) {
            if (JSON.stringify(response.data) !== JSON.stringify(dataList)) {
                currentPage = 0;
                currentList = [];

                dataList = [];
                dataList = response.data;
                loadMore();
            }
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    function call(number) {
        if (number != "") {
            window.location.href = `tel:${number}`;
        }
    }

    function goBack() {
        if (page == "list") {
            push(`/AsList`);
        } else {
            push(`/AsDtl/${page.split("_")[0]}/${page.split("_")[1]}`);
        }
    }

    // 페이지가 로드될 때 goBack 등록
    store.currentGoBack.set(goBack);

    // 페이지 벗어나면 해제
    onDestroy(() => {
        store.currentGoBack.set(null);
    });
</script>

<Header {goBack} />

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section
    class="main inner main-pad-36 main-gray scroll-custom"
    style="width: 100%; position: relative; height: 100vh; overflow-y: auto"
    on:scroll={handleScroll}
>
    <div class="mobile">
        <div style="background: #FFF; padding-bottom: 26px;">
            <div class="cmn-title-left gray-width" style="padding-top: 20px;">
                <p>A/S 수리 내역</p>
            </div>
        </div>

        <div id="item-list_m">
            {#if currentList.length > 0}
                {#each currentList as data}
                    <div style="margin-top: 15px; background: #FFF;">
                        <div class="gray-width">
                            <div class="cart-order-list">
                                <div class="order-dtl">
                                    <p>
                                        {data.rcept_DE
                                            .replace(/\.\d+$/, "")
                                            .replaceAll("-", ".")}
                                    </p>
                                    <div
                                        class="order-dtl-in"
                                        on:click={() => {
                                            push(
                                                `/AsDtl/${data.rcept_NO}/${data.rcept_SN}`
                                            );
                                        }}
                                    >
                                        <p>내역 상세</p>
                                        <img
                                            src="resource/img/ico_arrow_right.png"
                                            alt=""
                                        />
                                    </div>
                                </div>

                                <ul>
                                    <li>
                                        <div class="list-in">
                                            <p class="list-title">거래처명</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.bcnc_NM ?? ""}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">
                                                거래처 주소
                                            </p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.bcnc_ADDR ?? ""}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">
                                                거래처 연락처
                                            </p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p
                                                on:click={() => {
                                                    call(data.bcnc_TELNO ?? "");
                                                }}
                                            >
                                                {data.bcnc_TELNO ?? ""}
                                            </p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">모델명</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.item_NM ?? ""}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">처리 담당</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.asgn_EMPL_NM ?? ""}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">납품일자</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.shipmnt_DE ?? ""}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">유상무상</p>
                                        </div>
                                        <div class="list-in list-in_">
                                            <p>{data.pay_SE_NM ?? ""}</p>
                                        </div>

                                        <div class="list-in">
                                            <p class="list-title">접수내용</p>
                                        </div>
                                        <div class="list-in">
                                            <!-- prettier-ignore -->
                                            <textarea
                                                style="width:100%; height:87px"
                                                readonly
                                            >{data.rcept_CN ?? ""}</textarea>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                {/each}
            {:else}
                <p>검색 결과가 없습니다.</p>
            {/if}
        </div>
    </div>
</section>

<style>
    p {
        white-space: unset;
    }

    .list-in_ {
        border-bottom: 1px solid;
    }
</style>
